import { Money } from '@graphcommerce/magento-store'
import { filterNonNullableKeys } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { Box, Stack, SxProps, Theme, Typography } from '@mui/material'
import { ProductPagePriceFragment } from './ProductPagePrice.gql'

export type ProductPagePriceTiersProps = {
  sx?: SxProps<Theme>
  product: ProductPagePriceFragment
}

export function ProductPagePriceTiers(props: ProductPagePriceTiersProps) {
  const { product, sx = [] } = props
  // console.log({ProductPagePriceTiers: product})
  const priceTiers = filterNonNullableKeys(product?.price_tiers, [
    'quantity',
    'final_price',
    'discount',
  ])

  if (!priceTiers.length) return null

  console.log({priceTiers})
  return (
    <Stack direction="column" bgcolor="rgba(73, 25, 61, 0.1)"  spacing={0} borderRadius={4}>
      {priceTiers.map(({ quantity, final_price, discount }, index) => (
        <Box key={quantity} borderBottom={index === priceTiers.length -1 ? "" : "1px solid #e5e5e5"} px={2} py={1} fontSize={16}>
          
          <Trans
            id='Buy {quantity} for <0/> and save {percent}%'
            components={{ 0: <span style={{color: "rgba(73, 25, 61)", fontWeight: "bold"}}><Money {...final_price} /></span> }}
            values={{ quantity, percent: discount.percent_off }}
          />
          
        </Box>
      ))}
    </Stack>
  )
}
